import { render, staticRenderFns } from "./jobposition.vue?vue&type=template&id=219f7d20&"
import script from "./jobposition.vue?vue&type=script&lang=js&"
export * from "./jobposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports